import React, { Component } from "react";
import { connect } from "react-redux";
import ProductHeader from "../ProductDetails/ProductHeader";
import CountriesList from "./CountrySelect/CountriesList";
import AreaSelect from "./AreasSelect";
import ActionButton from "../ActionButton";
import ChangeDeliveryTypeDialog from "../CheckoutProcess/SecondStep/ChangeDeliveryTypeDialog";
import {
  fetchBranch,
  fetchStore,
  refreshStorefrontOrderPassData,
  setBranchDeliveryCharge,
  updateMOV,
} from "../../store/actions";
import { clearCart } from "../../store/actions/cart";
import { modifyAddress } from "../../store/actions/customers";
import ServiceType from "./ServiceType";
import Pickup from "./Pickup";
import Addresses from "../CheckoutProcess/Confirmation/Addresses";
import BranchSelectDrawer from "../BranchSelect/BranchSelectDrawer";
import { fetchDeliveryCharges } from "../../store/actions/store";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Redirect } from "react-router-dom";
import {
  getSavedAddresses,
  isOrderPassPhoneVerified,
  shouldRequireOrderPassVerification,
} from "../../Helpers/orderPass";
import {
  orderPassButtonStyle,
  orderPassModalActionsStyle,
  orderPassModalContentStyle,
  orderPassModalPaperStyle,
  orderPassModalTitleStyle,
} from "../../Helpers/orderPassUi";

const normalizeCountryName = (name) =>
  `${name || ""}`
    .replace(/[\u200B-\u200F\u202A-\u202E\u2060\uFEFF]/g, "")
    .trim()
    .toLowerCase();

class index extends Component {
  pickupSelectionCommitted = false;

  state = {
    selectedServiceType: this.props.settings.is_menu
      ? 1
      : (this.props.history.location.state?.type + 1 ||
          this.props.address?.selectedDeliveryType + 1) - 1,
    selectedCountryID: this.props.countries[0]?.id,
    branchDeliveryChargeID: null,

    dialogOpen: false,

    selectedPickupBranch: null,

    addressesOpen: false,
    addressesOpenSource: "",
    hasAutoOpenedOrderPassAddresses: false,
    showAllOrderPassAddressOptions: false,

    openBranchSelectDrawer: false,

    tempDeliveryCharge: null,
    temporaryAddress: {},
  };

  goBackFromAreaSelect = () => {
    const routeState = this.props.history.location.state || {};
    const previousPath = routeState.prevPath;

    this.restorePreviousCheckoutSelection(routeState);

    if (previousPath) {
      this.props.history.replace(previousPath);
      return;
    }

    if (
      this.props.settings.enable_orderpass &&
      routeState.orderPassEntry === "area_select"
    ) {
      this.props.history.replace("/");
      return;
    }

    this.props.history.goBack();
  };

  restorePreviousCheckoutSelection = (routeState = {}) => {
    const shouldRestore =
      routeState.newAddress || routeState.pickupFromAddressPicker;

    if (!shouldRestore) return;

    if (routeState.previousAddress) {
      this.props.modifyAddress(routeState.previousAddress);
    }
    if (routeState.previousBranch) {
      this.props.setBranchDeliveryCharge({
        bdc: routeState.previousBranch.bdc,
        branch: routeState.previousBranch.branch,
        isPickup: routeState.previousBranch.isPickup,
      });
    }
  };

  markPickupSelectionCommitted = () => {
    if (
      this.props.history.location.state?.pickupFromAddressPicker &&
      this.state.selectedServiceType === 1 &&
      this.state.selectedPickupBranch
    ) {
      this.pickupSelectionCommitted = true;
    }
  };

  isCreatingOrderPassAddress = () =>
    !!this.props.history.location?.state?.newAddress;

  getNewAddressRouteState = () =>
    this.isCreatingOrderPassAddress()
      ? {
          prevPath: this.props.history.location.state?.prevPath,
          newAddress: true,
          orderPassEntry: this.props.history.location.state?.orderPassEntry,
          previousAddress:
            this.props.history.location.state?.previousAddress || null,
          previousBranch:
            this.props.history.location.state?.previousBranch || null,
        }
      : undefined;

  componentDidUpdate = (prevProps) => {
    if (
      this.props.countries?.length &&
      (this.props.countries.length !== prevProps.countries.length ||
        !this.state.selectedCountryID)
    ) {
      this.setState({ selectedCountryID: this.props.countries[0].id });
    }
    if (
      this.props.orderPassAddresses !== prevProps.orderPassAddresses ||
      this.props.orderPassVerifiedPhone !== prevProps.orderPassVerifiedPhone ||
      this.props.customerContact?.phone !== prevProps.customerContact?.phone
    ) {
      this.maybeOpenOrderPassAddressDrawer();
    }
  };

  componentWillUnmount = () => {
    const routeState = this.props.history.location.state || {};

    if (
      routeState.pickupFromAddressPicker &&
      !this.pickupSelectionCommitted &&
      this.props.address?.selectedDeliveryType === 1 &&
      !this.props.address?.pickupArea
    ) {
      this.restorePreviousCheckoutSelection(routeState);
    }
  };

  hasSelectedDeliveryAddress = () => {
    const { address } = this.props;
    if (!address || address.selectedDeliveryType === 1) return false;
    return Boolean(
      address.orderPassAddressId ||
        (address.country &&
          address.area &&
          (address.block ||
            address.street ||
            address.building ||
            address.gpsConfirmed)),
    );
  };

  shouldAutoOpenOrderPassAddresses = () => {
    const { settings } = this.props;
    if (!settings.enable_orderpass) return false;
    if (this.state.hasAutoOpenedOrderPassAddresses || this.state.addressesOpen)
      return false;
    if (this.props.history.location?.state?.newAddress) return false;
    if (
      this.props.history.location?.state?.pickupOnly ||
      this.props.cartHasPickupOnly
    )
      return false;
    if (
      !(
        settings.enable_delivery ||
        settings.enable_delivery_select ||
        this.props.history.location?.state?.deliveryOnly
      )
    )
      return false;
    if (
      !isOrderPassPhoneVerified(
        this.props.customerContact,
        this.props.orderPassVerifiedPhone,
      )
    )
      return false;
    if (this.hasSelectedDeliveryAddress()) return false;
    return this.state.selectedServiceType === 0;
  };

  getAvailableOrderPassAddresses = (addresses = this.props.orderPassAddresses) =>
    this.props.settings?.enable_orderpass
      ? (addresses || []).filter(
          (savedAddress) =>
            savedAddress?.orderPassMatched && savedAddress?.checkoutAddress,
        )
      : [];

  getOrderPassAddressOrderCount = (address) =>
    Number(address?.order_count || address?.count || 0) || 0;

  getRankedOrderPassAddresses = (addresses = this.props.orderPassAddresses) => {
    const availableAddresses = this.getAvailableOrderPassAddresses(addresses);
    const withIndex = availableAddresses.map((address, index) => ({
      address,
      index,
    }));
    const defaultAddress =
      withIndex.find(({ address }) => address?.is_default) ||
      withIndex.find(({ address }) => address?.is_preferred);
    const sortedByOrderCount = withIndex
      .filter(({ address }) => address !== defaultAddress?.address)
      .sort((left, right) => {
        const countDifference =
          this.getOrderPassAddressOrderCount(right.address) -
          this.getOrderPassAddressOrderCount(left.address);
        if (countDifference !== 0) return countDifference;
        return left.index - right.index;
      });

    return [
      ...(defaultAddress ? [defaultAddress.address] : []),
      ...sortedByOrderCount.map(({ address }) => address),
    ];
  };

  getVisibleOrderPassAddresses = () => {
    const rankedAddresses = this.getRankedOrderPassAddresses();
    if (this.state.showAllOrderPassAddressOptions) return rankedAddresses;
    return rankedAddresses.slice(0, 3);
  };

  closeOrderPassAddressModal = () => {
    this.setState({
      addressesOpen: false,
      addressesOpenSource: "",
      showAllOrderPassAddressOptions: false,
    });
  };

  formatOrderPassAddressTitle = (address) => {
    const { language } = this.props;
    return language == "english"
      ? address.area__name || address.area_name || address.name || ""
      : address.area__ar_name || address.area__name || address.area_name || "";
  };

  formatOrderPassAddressDetails = (address) => {
    const { language, settings } = this.props;
    const normalizedCountryName = normalizeCountryName(address.country__name);
    const isQatar = normalizedCountryName === "qatar";
    const isEgypt = normalizedCountryName === "egypt";
    const isBahrain = normalizedCountryName === "bahrain";
    const details = [];

    const block = isQatar ? address.zone : address.block;
    if (block) {
      details.push(
        `${
          language == "english"
            ? isQatar
              ? "Zone"
              : isEgypt
                ? "Area"
                : "Block"
            : isQatar
              ? "منطقة"
              : isEgypt
                ? "منطقة"
                : isBahrain
                  ? "مجمع"
                  : "قطعة"
        } ${block}`,
      );
    }
    if (address.street) {
      details.push(`${language == "english" ? "St." : "شارع"} ${address.street}`);
    }
    if (address.building) {
      details.push(
        `${language == "english" ? "Building" : "مبنى"} ${address.building}`,
      );
    }
    if (address.floor) {
      details.push(
        `${language == "english" ? "Floor" : "الدور"} ${address.floor}`,
      );
    }
    if (address.apartment) {
      details.push(
        `${language == "english" ? "Apartment" : "شقة"} ${address.apartment}`,
      );
    }
    if (address.additional) {
      details.push(address.additional);
    }
    if (
      settings.is_branch_based_ordering &&
      address.branch_delivery_charge__branch__name
    ) {
      details.push(
        language == "english"
          ? `from ${address.branch_delivery_charge__branch__name} branch`
          : `من فرع ${address.branch_delivery_charge__branch__ar_name}`,
      );
    }

    return details.join(", ");
  };

  handleSelectOrderPassAddress = (savedAddress) => {
    if (!savedAddress?.checkoutAddress) return;

    this.props.switchAddress(
      savedAddress,
      this.props.settings.is_branch_based_ordering,
    );

    if (this.props.settings.is_branch_based_ordering) {
      this.props.updateBranch(savedAddress);
      this.props.setBranchDeliveryCharge({
        bdc: savedAddress.branch_delivery_charge_id,
        branch: savedAddress.branch_delivery_charge__branch__id,
        isPickup: false,
      });
      this.props.updateMOV(
        this.props.branch_delivery_charges.find(
          (bdc) => bdc.id == savedAddress.branch_delivery_charge_id,
        )?.minimum_order_value || 0,
      );
    }

    this.closeOrderPassAddressModal();
    if (
      this.props.cart.length + this.props.promo_items.length > 0 ||
      this.props.history.location?.state?.checkout
    ) {
      this.props.history.push("/checkout/confirmation");
      return;
    }
    this.props.history.replace("/");
  };

  handleCreateOrderPassAddressFromModal = () => {
    this.setState({
      addressesOpen: false,
      addressesOpenSource: "",
      hasAutoOpenedOrderPassAddresses: true,
      showAllOrderPassAddressOptions: false,
    });
  };

  redirectToPickupBranchSelection = () => {
    const pickupBranches = this.props.branches.filter(
      (branch) => branch.enable_pickup == true,
    );
    this.closeOrderPassAddressModal();
    this.props.modifyAddress({
      selectedDeliveryType: 1,
      pickupArea: null,
      area: null,
      country: null,
      orderPassAddressId: null,
    });
    this.setState({
      selectedServiceType: 1,
      branchDeliveryChargeID: null,
      selectedPickupBranch:
        pickupBranches.length === 1 ? pickupBranches[0].id : null,
      hasAutoOpenedOrderPassAddresses: true,
    });
  };

  hasPickupAvailable = () =>
    (this.props.settings.enable_pickup ||
      this.props.settings.enable_pickup_select) &&
    !this.props.settings.is_menu &&
    (this.props.branches || []).some((branch) => branch.enable_pickup == true);

  maybeOpenOrderPassAddressDrawer = async ({ refresh = false } = {}) => {
    if (!this.shouldAutoOpenOrderPassAddresses()) return;

    let savedAddresses = this.getAvailableOrderPassAddresses();

    if (!savedAddresses.length && refresh && this.props.orderPassStorefrontToken) {
      const refreshedOrderPassData =
        await this.props.refreshStorefrontOrderPassData();
      savedAddresses = this.getAvailableOrderPassAddresses(
        refreshedOrderPassData?.addresses || this.props.orderPassAddresses,
      );
    }

    if (!savedAddresses.length || !this.shouldAutoOpenOrderPassAddresses()) {
      return;
    }

    this.setState({
      addressesOpen: true,
      addressesOpenSource: "orderPassEntry",
      hasAutoOpenedOrderPassAddresses: true,
      showAllOrderPassAddressOptions: false,
    });
  };
  shouldShowSaveButton = () => {
    const { settings } = this.props;
    if (
      !!this.state.branchDeliveryChargeID ||
      !!this.state.selectedPickupBranch
    )
      return true;

    if (settings.enable_map_pin_selection && !this.state.selectedPickupBranch) {
      if (!this.state.branchDeliveryChargeID) return true;
    }
    return false;
  };

  shouldGoToAddressPage = () => {
    const { auth, settings } = this.props;
    if (
      settings.enable_orderpass &&
      this.props.history.location.state?.orderPassEntry === "area_select" &&
      this.state.selectedServiceType === 0
    )
      return true;
    if (
      this.props.history.location.state?.goBackToAddressPage &&
      this.state.selectedServiceType === 0
    )
      return true;
    let totalCartLength =
      this.props.cart.length + this.props.promo_items.length;
    // if (
    //   settings.enable_social_auth &&
    //   settings.enable_social_auth_staff &&
    //   auth.user &&
    //   totalCartLength > 0
    // ) {
    //   return true;
    // }
    return false;
  };

  shouldGoToCheckoutPage = () => {
    const { auth, settings } = this.props;
    if (this.props.history.location.state?.checkout)
      return true;
    let totalCartLength =
      this.props.cart.length + this.props.promo_items.length;
    // if (
    //   settings.enable_social_auth &&
    //   settings.enable_social_auth_staff &&
    //   auth.user &&
    //   totalCartLength > 0
    // ) {
    //   return true;
    // }
    return false;
  };

  getAddressFieldsToReset = (forceReset = false) => {
    const { branchDeliveryChargeID, selectedServiceType } = this.state;
    const { branch, address, settings } = this.props;

    let fields = [
      "block",
      "street",
      "building",
      "avenue",
      "floor",
      "paci",
      "additional",
      "apartment",
      "home_picture",
      "lat",
      "lng",
    ];
    if (settings.enable_map_pin_selection)
      fields = fields.filter(
        (x) => !["lat", "lng", "block", "street"].includes(x),
      );
    let fieldDict = {};
    const isDeliveryAndSameBDC =
      selectedServiceType === 0 &&
      ((settings.is_branch_based_ordering &&
        branchDeliveryChargeID === branch.bdc) ||
        (!settings.branch_based_ordering &&
          branchDeliveryChargeID === address?.area));
    fields.forEach((field) => {
      if (isDeliveryAndSameBDC && !forceReset)
        fieldDict[field] = !!address ? address[field] || "" : "";
      else fieldDict[field] = "";
    });
    if (this.isCreatingOrderPassAddress()) {
      fieldDict.orderPassAddressId = null;
    }

    return fieldDict;
  };
  clearCartAndChangeBranch = (forceCurrency = null) => {
    this.markPickupSelectionCommitted();
    const {
      branch_delivery_charges,
      branch,
      address,
      cart,
      promo_items,
      settings,
    } = this.props;
    const {
      branchDeliveryChargeID,
      selectedServiceType,
      selectedPickupBranch,
    } = this.state;
    this.props.branch.loading = true;
    const bdcObj = branch_delivery_charges.find(
      (bdc) => bdc.id === branchDeliveryChargeID,
    );
    this.props.fetchBranch(
      selectedServiceType === 0 ? "delivery" : "pickup",
      selectedServiceType === 0
        ? branchDeliveryChargeID
        : bdcObj?.branch || selectedPickupBranch,
      this.props.cart,
      this.props.applied_promo,
      this.props.history,
      forceCurrency,
      null,
      bdcObj?.branch || selectedPickupBranch,
    );
    this.props.setBranchDeliveryCharge({
      bdc: branchDeliveryChargeID,
      branch: bdcObj?.branch || selectedPickupBranch,
      isPickup: selectedServiceType == 0 ? false : true,
    });
    this.props.modifyAddress({
      gpsConfirmed:
        settings.enable_map_pin_selection && selectedServiceType === 0
          ? true
          : selectedServiceType === 0 && branchDeliveryChargeID === branch.bdc
            ? address?.gpsConfirmed || false
            : false,
      selectedDeliveryType: selectedServiceType,
      pickupArea: selectedServiceType === 0 ? null : selectedPickupBranch,
      area: selectedServiceType === 0 ? bdcObj.area_id : null,
      country: selectedServiceType === 0 ? bdcObj.country_id : null,
      selectedAddressType: 0,
      ...this.getAddressFieldsToReset(),
    });

    //Change this function
    //this.props.clearCart();
    if (
      this.props.history.location?.state?.pickupOnly ||
      this.props.history.location?.state?.deliveryOnly
    )
      this.props.history.goBack();
    else if (!this.props.should_force_area_select) {
      let totalCartLength = cart.length + promo_items.length;
      const nextPath = this.shouldGoToAddressPage()
        ? "/checkout/address"
        : this.shouldGoToCheckoutPage()
          ? "/checkout/confirmation"
          : totalCartLength > 0
            ? "/cart"
            : "/checkout/confirmation";
      this.props.history.replace(
        nextPath,
        nextPath === "/checkout/address"
          ? this.getNewAddressRouteState()
          : undefined,
      );
    } else this.props.history.replace("/");
  };

  setServiceType = (val) => {
    this.setState({ selectedServiceType: val });
    if (val === 0) this.setState({ selectedPickupBranch: null });
    else {
      let pickupBranches = this.props.branches.filter(
        (b) => b.enable_pickup == true,
      );
      if (pickupBranches.length === 1) {
        const id = pickupBranches[0].id;
        this.setState({ selectedPickupBranch: id });
      }
      this.setState({
        selectedCountryID: this.props.countries[0]?.id,
        branchDeliveryChargeID: null,
      });
    }
  };

  askForCarInfo = (branch) => {
    const { settings } = this.props;
    if (
      ((!settings.is_branch_based_ordering && settings.ask_for_car_info) ||
        (settings.is_branch_based_ordering &&
          this.props.branches.find((b) => b.id === branch)
            ?.ask_for_car_info)) &&
      branch
    ) {
      return true;
    }
    return false;
  };
  componentDidMount = async () => {
    if (!this.props.fetchedDeliveryCharges) {
      await this.props.fetchDeliveryCharges(this.props.country_code);
    }
    window.scrollTo(0, 0);
    if (
      !(
        this.props.settings.enable_delivery ||
        this.props.settings.enable_delivery_select
      ) ||
      this.props.history.location?.state?.type === 1 ||
      this.props.history.location?.state?.pickupOnly ||
      this.props.cartHasPickupOnly
    ) {
      if (!this.props.history.location?.state?.deliveryOnly) {
        this.setState({ selectedServiceType: 1 });
      }
    }
    if (
      this.props.history.location.state &&
      this.props.history.location.state.prevPath &&
      this.props.history.location.state.prevPath.includes("checkout") &&
      this.props.address &&
      this.props.settings.is_branch_based_ordering
    ) {
      this.setState({
        selectedServiceType: this.props.address?.selectedDeliveryType,
      });
    }

    if (
      !this.state.selectedServiceType &&
      this.state.selectedServiceType !== 0 &&
      !(
        this.props.history.location?.state?.pickupOnly ||
        this.props.history.location?.state?.deliveryOnly
      )
    ) {
      this.setDefaultServiceType();
    }
    if (
      this.props.history.location.state?.newAddress ||
      this.props.cartHasDeliveryOnly ||
      this.props.history.location?.state?.deliveryOnly
    ) {
      if (!this.props.history.location?.state?.pickupOnly) {
        this.setState({ selectedServiceType: 0 });
      }
    }
    if (this.state.selectedServiceType === 1) {
      let pickupBranches = this.props.branches.filter(
        (b) => b.enable_pickup == true,
      );
      if (pickupBranches.length === 1) {
        const id = pickupBranches[0].id;
        this.setState({ selectedPickupBranch: id });
      } else if (pickupBranches.length === 0) {
        this.setState({ selectedServiceType: 0 });
      }
    }

    if (
      this.props.address?.country &&
      !!this.props.countries?.find((c) => c.id === this.props.address?.country)
    )
      this.setState({ selectedCountryID: this.props.address?.country });

    window.setTimeout(
      () => this.maybeOpenOrderPassAddressDrawer({ refresh: true }),
      0,
    );
  };
  setDefaultServiceType = () => {
    if (
      this.props.settings.enable_delivery ||
      this.props.settings.enable_delivery_select
    ) {
      this.setState({ selectedServiceType: 0 });
    } else if (
      this.props.settings.enable_pickup ||
      this.props.settings.enable_pickup_select
    ) {
      this.setState({ selectedServiceType: 1 });
    }
  };

  resetShouldForceAreaSelect = () => {
    if (this.props.should_force_area_select) {
      this.props.resetShouldForceAreaSelect();
    }
  };

  render() {
    const {
      branch,
      language,
      settings,
      branch_delivery_charges,
      cart,
      promo_items,
      countries,
      address,
    } = this.props;
    if (
      shouldRequireOrderPassVerification(
        settings,
        this.props.customerContact,
        this.props.orderPassVerifiedPhone,
        this.props.orderPassGuestBypassPhone,
      )
    )
      return (
        <Redirect
          to={{
            pathname: "/checkout/details",
            search: "?orderpass_entry=area_select",
          }}
        />
      );
    const savedAddresses = getSavedAddresses(
      this.props.auth,
      this.props.orderPassAddresses,
      this.props.settings,
    );
    const visibleOrderPassAddressOptions = this.getVisibleOrderPassAddresses();
    const hasMoreOrderPassAddressOptions =
      this.getAvailableOrderPassAddresses().length >
      visibleOrderPassAddressOptions.length;
    const hasPickupAvailable = this.hasPickupAvailable();
    const {
      selectedCountryID,
      branchDeliveryChargeID,
      selectedServiceType,
      selectedPickupBranch,
    } = this.state;
    let totalCartLength = cart.length + promo_items.length;

    if (!this.props.fetchedDeliveryCharges)
      return (
        <div
          style={{
            minHeight: "100vh",
            backgroundColor: "#F5F5F5",
          }}
        >
          <ProductHeader
            onBack={this.goBackFromAreaSelect}
            hideBackButton={
              (!branch.branch && settings.force_select_branch) ||
              this.props.should_force_area_select
            }
          />
          <div style={{ marginTop: 86 }}></div>
          <CircularProgress
            color="primary"
            style={{
              alignSelf: "center",
              justifySelf: "center",
              width: 30,
              height: 30,
            }}
          />
        </div>
      );
    return (
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#F5F5F5",
        }}
      >
        {this.state.addressesOpen &&
          this.state.addressesOpenSource === "orderPassEntry" && (
            <Dialog
              open={this.state.addressesOpen}
              onClose={(event, reason) => {
                if (["backdropClick", "escapeKeyDown"].includes(reason)) return;
                this.closeOrderPassAddressModal();
              }}
              aria-labelledby="orderpass-address-dialog-title"
              PaperProps={{
                style: orderPassModalPaperStyle({
                  width: 420,
                  maxWidth: "calc(100% - 24px)",
                  maxHeight: "calc(100vh - 48px)",
                }),
              }}
            >
              <DialogTitle
                id="orderpass-address-dialog-title"
                disableTypography
                style={orderPassModalTitleStyle(language, {
                  padding:
                    language === "english"
                      ? "24px 56px 24px 24px"
                      : "24px 24px 24px 56px",
                  position: "relative",
                  textAlign: language === "arabic" ? "right" : "left",
                })}
              >
                <h2
                  style={{
                    fontFamily: language === "english" ? "Quicksand" : "Cairo",
                    fontSize: 20,
                    fontWeight: 500,
                    margin: 0,
                  }}
                >
                  {language === "english"
                    ? "Choose a saved address"
                    : "اختر عنوانا محفوظا"}
                </h2>
                <IconButton
                  aria-label={language === "english" ? "Close" : "اغلاق"}
                  onClick={this.closeOrderPassAddressModal}
                  style={{
                    position: "absolute",
                    top: 8,
                    right: language === "english" ? 8 : "unset",
                    left: language === "arabic" ? 8 : "unset",
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent
                style={orderPassModalContentStyle({
                  maxHeight: "min(56vh, 520px)",
                  overflowY: "auto",
                })}
              >
                {visibleOrderPassAddressOptions.map((savedAddress) => (
                  <button
                    type="button"
                    key={savedAddress.id}
                    onClick={() =>
                      this.handleSelectOrderPassAddress(savedAddress)
                    }
                    style={{
                      width: "100%",
                      border: "1px solid #d9d9d9",
                      borderRadius: 6,
                      backgroundColor: "#fff",
                      padding: "14px 16px",
                      textAlign: language === "arabic" ? "right" : "left",
                      marginBottom: 12,
                      cursor: "pointer",
                    }}
                  >
                    <p
                      className="mb-1 bold"
                      style={{ color: "#333", fontSize: 14 }}
                    >
                      {this.formatOrderPassAddressTitle(savedAddress)}
                    </p>
                    <p
                      className="mb-0"
                      style={{ color: "#666", fontSize: 13, lineHeight: 1.5 }}
                    >
                      {this.formatOrderPassAddressDetails(savedAddress)}
                    </p>
                  </button>
                ))}
                {hasMoreOrderPassAddressOptions && (
                  <Button
                    variant="outlined"
                    color="primary"
                    disableElevation
                    onClick={() =>
                      this.setState({ showAllOrderPassAddressOptions: true })
                    }
                    style={orderPassButtonStyle({
                      width: "100%",
                    })}
                  >
                    {language === "english" ? "Show more ↓" : "عرض المزيد ↓"}
                  </Button>
                )}
              </DialogContent>
              <DialogActions
                style={orderPassModalActionsStyle({
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                })}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  disableElevation
                  onClick={this.handleCreateOrderPassAddressFromModal}
                  style={orderPassButtonStyle({
                    width: "100%",
                    marginBottom: hasPickupAvailable ? 12 : 0,
                  })}
                >
                  {language === "english"
                    ? "Create a new address"
                    : "إنشاء عنوان جديد"}
                </Button>
                {hasPickupAvailable && (
                  <Button
                    variant="text"
                    color="primary"
                    disableElevation
                    onClick={this.redirectToPickupBranchSelection}
                    style={orderPassButtonStyle({
                      width: "100%",
                      marginLeft: 0,
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    })}
                  >
                    {language === "english"
                      ? "Pick up instead"
                      : "الاستلام من الفرع بدلا من ذلك"}
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          )}
        {this.state.addressesOpen &&
          this.state.addressesOpenSource !== "orderPassEntry" &&
          !!savedAddresses.length &&
          this.state.selectedServiceType === 0 && (
            <Addresses
              open={this.state.addressesOpen}
              onClose={() => {
                this.setState({
                  addressesOpen: false,
                  addressesOpenSource: "",
                  branchDeliveryChargeID: null,
                });
              }}
              extraAction={() => {
                this.setState({
                  addressesOpen: false,
                  addressesOpenSource: "",
                });
                if (
                  this.state.addressesOpenSource === "orderPassEntry" &&
                  totalCartLength <= 0 &&
                  !this.props.history.location?.state?.checkout
                ) {
                  this.props.history.replace("/");
                  return;
                }
                this.props.history.push("/checkout/confirmation");
              }}
              comingFrom={
                this.state.addressesOpenSource === "orderPassEntry"
                  ? "orderPassAreaSelect"
                  : "branchSelect"
              }
              onAddNewAddress={() => {
                if (this.state.addressesOpenSource === "orderPassEntry") {
                  this.setState({
                    addressesOpen: false,
                    addressesOpenSource: "",
                    hasAutoOpenedOrderPassAddresses: true,
                  });
                  return;
                }
                if (settings.is_branch_based_ordering) {
                  const bdcObj = branch_delivery_charges.find(
                    (bdc) => bdc.id === branchDeliveryChargeID,
                  );

                  const branchID = bdcObj?.branch;
                  if (!branchID) return;

                  this.props.setBranchDeliveryCharge({
                    bdc: branchDeliveryChargeID,
                    branch: branchID,
                    isPickup: false,
                  });

                  this.props.updateMOV(bdcObj.minimum_order_value);

                  this.props.modifyAddress({
                    gpsConfirmed:
                      bdcObj.id === branch.bdc
                        ? address?.gpsConfirmed || false
                        : false,
                    selectedDeliveryType: 0,
                    pickupArea: null,
                    area: bdcObj.area_id,
                    country: bdcObj.country_id,
                    selectedAddressType:
                      bdcObj.id === branch.bdc
                        ? address?.selectedAddressType || 0
                        : 0,
                    ...this.getAddressFieldsToReset(true),
                    gpsConfirmed: false,
                  });

                  this.props.history.push(
                    "/checkout/address",
                    this.getNewAddressRouteState(),
                  );

                  if (branchID !== branch.branch)
                    window.setTimeout(() => window.location.reload(), 200);
                } else {
                  this.props.modifyAddress({
                    selectedDeliveryType: 0,
                    area: branchDeliveryChargeID,
                    country: this.props.areas.find(
                      (a) => a.id === branchDeliveryChargeID,
                    )?.country,
                    gpsConfirmed:
                      branchDeliveryChargeID === address?.area
                        ? address?.gpsConfirmed || false
                        : false,
                    ...this.getAddressFieldsToReset(true),
                    pickupArea: null,
                    selectedAddressType: 0,
                    gpsConfirmed: false,
                  });
                  this.props.history.push(
                    "/checkout/address",
                    this.getNewAddressRouteState(),
                  );
                }
              }}
              bdcID={branchDeliveryChargeID}
            />
          )}
        {this.state.openBranchSelectDrawer && (
          <BranchSelectDrawer
            deliveryCharge={this.state.tempDeliveryCharge}
            onClose={() =>
              this.setState({
                tempDeliveryCharge: null,
                openBranchSelectDrawer: false,
              })
            }
            handleContinue={(bdcID) => {
              this.setState({ branchDeliveryChargeID: bdcID });
              this.setState({
                tempDeliveryCharge: null,
                openBranchSelectDrawer: false,
              });
            }}
          />
        )}
        <ChangeDeliveryTypeDialog
          yes={() => this.clearCartAndChangeBranch()}
          dialogOpen={this.state.dialogOpen}
          onClose={() => {
            this.setState({ dialogOpen: false });
          }}
        />
        <ProductHeader
          onBack={this.goBackFromAreaSelect}
          hideBackButton={
            (!branch.branch && settings.force_select_branch) ||
            this.props.should_force_area_select
          }
        />
        <div style={{ marginTop: 86 }}></div>
        {!settings.is_menu && (
          <ServiceType
            setServiceType={this.setServiceType}
            selectedServiceType={selectedServiceType}
            pickupOnly={
              this.props.history.location?.state?.pickupOnly ||
              this.props.cartHasPickupOnly
            }
            deliveryOnly={
              this.props.history.location?.state?.deliveryOnly ||
              this.props.cartHasDeliveryOnly
            }
          />
        )}
        {selectedServiceType === 0 ? (
          <>
            {countries.length > 1 && (
              <CountriesList
                setSelectedCountry={(id) =>
                  this.setState({
                    selectedCountryID: id,
                    branchDeliveryChargeID: null,
                  })
                }
                selectedCountryID={selectedCountryID}
              />
            )}
            <AreaSelect
              selectedCountryID={selectedCountryID}
              branchDeliveryChargeID={branchDeliveryChargeID}
              setBranchDeliveryChargeID={(id) =>
                this.setState({ branchDeliveryChargeID: id })
              }
              setAddressesOpen={() =>
                this.setState({
                  addressesOpen: true,
                  addressesOpenSource: "branchSelect",
                })
              }
              OpenBranchSelectDrawer={(dcID) =>
                this.setState({
                  openBranchSelectDrawer: true,
                  tempDeliveryCharge: dcID,
                })
              }
              isInsidePolygon={(v) => this.setState({ isInsidePolygon: v })}
              setCountryID={(cid) => this.setState({ selectedCountryID: cid })}
              setLoading={(v) => this.setState({ loading: v })}
              temporaryAddress={this.state.temporaryAddress}
              setTemporaryAddress={(d) =>
                this.setState({ temporaryAddress: d })
              }
            />
          </>
        ) : (
          <>
            <Pickup
              selectedPickupBranch={this.state.selectedPickupBranch}
              setSelectedPickupBranch={(val) => {
                this.setState({ selectedPickupBranch: val });
              }}
            />
            <div className="free-space-58"></div>
          </>
        )}
        {this.shouldShowSaveButton() && (
          <ActionButton
            action={
              settings.enable_map_pin_selection &&
              !this.state.isInsidePolygon &&
              selectedServiceType === 0
                ? language === "arabic"
                  ? "عنوانك غير قابل للتوصيل"
                  : "Your location is outside delivery zone"
                : language == "english"
                  ? "Done"
                  : "حفظ"
            }
            allowWithMenu
            disabled={
              settings.enable_map_pin_selection &&
              !this.state.isInsidePolygon &&
              selectedServiceType === 0
            }
            loading={this.state.loading}
            addressPage={settings.enable_map_pin_selection}
            onClick={() => {
              if (!settings.is_branch_based_ordering) {
                this.markPickupSelectionCommitted();
                if (selectedServiceType === 0) {
                  const tempCountryID = this.props.areas.find(
                    (a) => a.id === branchDeliveryChargeID,
                  )?.country;
                  this.props.modifyAddress({
                    selectedDeliveryType: 0,
                    area: branchDeliveryChargeID,
                    country: tempCountryID,
                    gpsConfirmed:
                      branchDeliveryChargeID === address?.area
                        ? address?.gpsConfirmed || false
                        : false,
                    ...this.getAddressFieldsToReset(),
                    pickupArea: null,
                    selectedAddressType:
                      branchDeliveryChargeID === address?.area
                        ? address?.selectedAddressType || 0
                        : 0,
                  });
                  this.props.updateMOV(
                    this.props.areas.find(
                      (a) => a.id === branchDeliveryChargeID,
                    )?.minimun_order_value,
                  );
                  if (tempCountryID) {
                    const tempCountryObj = this.props.countries.find(
                      (c) => c.id === tempCountryID,
                    );
                    if (
                      tempCountryObj?.dial_code !==
                        this.props.currency.selected &&
                      settings.enable_currency_converter
                    ) {
                      this.props.fetchStore(
                        this.props.cart,
                        this.props.applied_promo,
                        this.props.history,
                        tempCountryObj?.dial_code,
                      );
                      this.props.history.replace("/");
                      return;
                    }
                  }
                } else {
                  this.props.modifyAddress({
                    selectedDeliveryType: 1,
                    pickupArea: selectedPickupBranch,
                    gpsConfirmed:
                      branchDeliveryChargeID === address?.area
                        ? address?.gpsConfirmed || false
                        : false,
                    ...this.getAddressFieldsToReset(),
                    area: null,
                    country: null,
                    selectedAddressType: undefined,
                  });

                  if (settings.enable_currency_converter) {
                    const tempPickupBranchObj = this.props.branches.find(
                      (b) => b.id === selectedPickupBranch,
                    );
                    if (
                      tempPickupBranchObj?.country_code !==
                      this.props.currency.selected
                    ) {
                      this.props.fetchStore(
                        this.props.cart,
                        this.props.applied_promo,
                        this.props.history,
                        tempPickupBranchObj.country_code,
                      );
                      this.props.history.replace("/");
                      return;
                    }
                  }
                }
                if (
                  this.props.history.location?.state?.pickupOnly ||
                  this.props.history.location?.state?.deliveryOnly
                ) {
                  this.props.history.goBack();
                } else
                  this.props.history.replace(
                    totalCartLength > 0 ? "/cart" : "/checkout/confirmation",
                  );
              } else {
                if (
                  settings.enable_map_pin_selection &&
                  selectedServiceType === 0
                ) {
                  this.props.modifyAddress({
                    lat: parseFloat(this.state.temporaryAddress?.lat),
                    lng: parseFloat(this.state.temporaryAddress?.lng),
                    gpsConfirmed: true,
                    street: this.state.temporaryAddress?.street,
                    building: this.state.temporaryAddress?.building,
                    block: this.state.temporaryAddress?.block,
                  });
                }
                const bdcObj = branch_delivery_charges.find(
                  (bdc) => bdc.id === branchDeliveryChargeID,
                );

                const branchID = bdcObj?.branch || selectedPickupBranch;
                const isDelivery = selectedServiceType === 0; // change later
                let new_country_code = null;
                if (isDelivery && bdcObj) {
                  new_country_code = this.props.countries.find(
                    (c) => c.id === bdcObj.country_id,
                  )?.dial_code;
                } else {
                  new_country_code = this.props.branches.find(
                    (b) => b.id === branchID,
                  )?.country_code;
                }
                if (!!branchDeliveryChargeID || !!selectedPickupBranch) {
                  if (
                    branchID === branch.branch &&
                    !settings.hide_irrelevant_products &&
                    branch.branch != null &&
                    (!settings.enable_currency_converter ||
                      new_country_code === this.props.currency.selected)
                  ) {
                    this.props.setBranchDeliveryCharge({
                      bdc: isDelivery ? branchDeliveryChargeID : null,
                      branch: branchID,
                      isPickup: !isDelivery,
                    });
                    if (isDelivery)
                      this.props.updateMOV(bdcObj.minimum_order_value);
                    else {
                      this.props.updateMOV(0);
                    }
                    this.props.modifyAddress({
                      gpsConfirmed:
                        settings.enable_map_pin_selection && isDelivery
                          ? true
                          : isDelivery && bdcObj.id === branch.bdc
                            ? address?.gpsConfirmed || false
                            : false,
                      selectedDeliveryType: isDelivery ? 0 : 1,
                      pickupArea: isDelivery ? null : selectedPickupBranch,
                      area: isDelivery ? bdcObj.area_id : null,
                      country: isDelivery ? bdcObj.country_id : null,
                      selectedAddressType:
                        isDelivery && bdcObj.id === branch.bdc
                          ? address?.selectedAddressType || 0
                          : !isDelivery
                            ? undefined
                            : 0,
                      ...this.getAddressFieldsToReset(),
                    });
                    if (
                      this.props.history.location?.state?.pickupOnly ||
                      this.props.history.location?.state?.deliveryOnly
                    ) {
                      this.resetShouldForceAreaSelect();
                      this.props.history.goBack();
                    } else {
                      if (this.props.should_force_area_select) {
                        this.resetShouldForceAreaSelect();
                        this.props.history.replace("/");
                      } else {
                        const nextPath = this.shouldGoToAddressPage()
                          ? "/checkout/address"
                          : this.shouldGoToCheckoutPage()
                            ? "/checkout/confirmation"
                            : totalCartLength > 0
                              ? "/cart"
                              : "/checkout/confirmation";
                        this.props.history.replace(
                          nextPath,
                          nextPath === "/checkout/address"
                            ? this.getNewAddressRouteState()
                            : undefined,
                        );
                      }
                    }
                  } else if (
                    settings.enable_currency_converter &&
                    new_country_code !== this.props.currency.selected
                  ) {
                    this.clearCartAndChangeBranch(new_country_code);
                  } else if (branch.branch == null) {
                    this.clearCartAndChangeBranch();
                  } else if (
                    (branchID != branch.branch ||
                      settings.hide_irrelevant_products) &&
                    branch.branch != null &&
                    totalCartLength > 0
                  ) {
                    this.setState({ dialogOpen: true });
                  } else {
                    this.clearCartAndChangeBranch();
                  }
                } else {
                }
              }
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    branches: state.store.store.branches,
    themeColor: state.store.store.settings.dark,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    branch: state.branch,
    address: state.customers.address,
    areas: state.store.store.areas,
    cart: state.cart.cart,
    applied_promo: state.cart.promos,
    settings: state.store.store.settings,
    customerContact: state.customers.customerContact,
    countries: state.store.store.all_countries || state.store.store.countries,
    thirdLoading: state.store.thirdLoading,
    promo_items: state.cart.promo_items,
    auth: state.auth,
    orderPassAddresses: state.customers.orderPassAddresses || [],
    orderPassVerifiedPhone: state.customers.orderPassVerifiedPhone,
    orderPassStorefrontToken: state.customers.orderPassStorefrontToken,
    orderPassGuestBypassPhone: state.customers.orderPassGuestBypassPhone,
    cartHasPickupOnly: state.cart.pickup_only_items > 0,
    cartHasDeliveryOnly: state.cart.delivery_only_items > 0,
    should_force_area_select: state.store.store.should_force_area_select,
    currency: state.currency,
    country_code: state.store.store.country_code,
    fetchedDeliveryCharges: state.store.fetchedDeliveryCharges,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchStore: (cart, promo, history, forceCurrency) =>
      dispatch(fetchStore(cart, promo, history, forceCurrency)),
    fetchBranch: (
      type,
      bdc_id,
      cart,
      promo,
      history,
      forceCurrency,
      QRValid,
      branchID,
    ) =>
      dispatch(
        fetchBranch(
          type,
          bdc_id,
          cart,
          promo,
          history,
          forceCurrency,
          QRValid,
          branchID,
        ),
      ),
    setBranchDeliveryCharge: (bdc_obj) =>
      dispatch(setBranchDeliveryCharge(bdc_obj)),
    clearCart: () => dispatch(clearCart()),
    modifyAddress: (obj) => dispatch(modifyAddress(obj)),
    updateMOV: (mov) => dispatch(updateMOV(mov)),
    switchAddress: (adrs, isBranchBased) =>
      dispatch({
        type: "SWITCH_ADDRESS",
        payload: { address: adrs, isBranchBased: isBranchBased },
      }),
    updateBranch: (adrs) => dispatch({ type: "UPDATE_BRANCH", payload: adrs }),
    clearAddress: () => dispatch({ type: "CLEAR_ADDRESS" }),
    resetShouldForceAreaSelect: () =>
      dispatch({ type: "RESET_SHOULD_FORCE_AREA_SELECT" }),
    clearStore: () => dispatch({ type: "CLEAR_STORE" }),
    fetchDeliveryCharges: (countryCode) =>
      dispatch(fetchDeliveryCharges(countryCode)),
    refreshStorefrontOrderPassData: () =>
      dispatch(refreshStorefrontOrderPassData()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(index);
